/** @jsxImportSource @emotion/react */
import * as React from "react";
import { VoucherTypeListItem as VoucherTypeListItemModel } from "../shop/model/GetVoucherTypeListSuccessResponse";
import { TableRow } from "../../components/table-components/TableRow";
import { TableCellLink } from "../../components/table-components/TableCellLink";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { firstTableCellStyle } from "../../style-util";
import {
  discountTypeBadgeBackgroundColors,
  discountTypeBadgeBorderColors,
  discountTypeBadgeTextColors,
  discountTypeLabels,
  formatDiscountValue,
  isoToHumanReadable,
} from "./@util/util";
import { SmallBadge } from "../../components/SmallBadge";
import { Country } from "../../model/Country";
import { getCountryInfo } from "../../service/countries-service";
import { css } from "@emotion/react";
import { formatDateWithYear } from "../../util";

interface Props {
  voucherType: VoucherTypeListItemModel;
  href: string;
  countries: Country[];
}

const noWrapStyle = css`
  white-space: nowrap;
`;

export const VoucherTypeListItem: React.FC<Props> = ({
  voucherType,
  href,
  countries,
}) => {
  const country = countries.find(
    (x) => x.countryCode === voucherType.countryCode
  );

  let duration = isoToHumanReadable(voucherType.duration);
  if (voucherType.expiresAt) {
    duration = `${duration} (at latest ${formatDateWithYear(
      voucherType.expiresAt
    )})`;
  }

  return (
    <TableRow>
      <TableCellLink href={href} css={firstTableCellStyle}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {voucherType.name}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText
          className="bodyTextRegular mb-0"
          color={colors.textPrimary}
          css={noWrapStyle}
        >
          {getCountryInfo(voucherType.countryCode).emojiFlag}{" "}
          {getCountryInfo(voucherType.countryCode).name}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <SmallBadge
          backgroundColor={discountTypeBadgeBackgroundColors.get(
            voucherType.discountType
          )}
          borderColor={discountTypeBadgeBorderColors.get(
            voucherType.discountType
          )}
        >
          <StyledText
            className="bodyTextRegular mb-0"
            color={discountTypeBadgeTextColors.get(voucherType.discountType)}
          >
            {discountTypeLabels.get(voucherType.discountType)}
          </StyledText>
        </SmallBadge>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {country?.currency
            ? formatDiscountValue(
                voucherType.discountValue,
                voucherType.discountType,
                country?.currency
              )
            : voucherType.discountValue}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {duration}
        </StyledText>
      </TableCellLink>
      <TableCellLink href={href}>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {voucherType.expiresAt
            ? formatDateWithYear(voucherType.expiresAt)
            : "-"}
        </StyledText>
      </TableCellLink>
    </TableRow>
  );
};

export default VoucherTypeListItem;
